import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Issue 1",
  "description": "",
  "published": "2006-05-12T00:00:00.000Z",
  "redirect_from": ["/blog/issue-1/swizec/418"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=show_comics/comic=1"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/sneeks/01_thumb.jpg",
          "alt": null
        }}></img></a></p>
    <p>{`This took longer than expected, but the first issue of Cthulhu is finally here. Don't feel like blabbering much right now, but there are things that need saying.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      